import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #f4f0ec;
  border-radius: 10px;
  padding: 16px;
  width: 100%;

  border: 2px solid #f4f0ec;
  color: #696969;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${(props) => props.isErrored
    && css`
      color: #c53030;
    `}

  ${(props) => props.isFocused
    && css`
      color: #696969;
      border-color: #696969;
    `}

  ${(props) => props.isFilled
    && css`
      color: #696969;
    `}

  input {
    flex: 1;
    background: transparent;
    border: 0;
    color: #666360;

    &::placeholder {
      color: #A9A9A9;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
      margin: 0px;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
